import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

function SubmitManuscriptCard() {
  return (
    <Box
      sx={{
        border: '1px solid #ff6f00',
        borderTop: '5px solid #e65100',
        p: 2,
        mt: 2,
        borderRadius: 0.5,
        backgroundColor: '#fff',
        maxWidth: 600,
        mx: 'auto',
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: 'bold', color: '#e65100', mb: 1 }}
      >
        Call for Papers!
      </Typography>

      <Typography variant="body2" sx={{ mb: 1.2 }}>
      Submissions are now open for Volume 3, Issue 1. We welcome orginal research
      articles, reviews and short communications across all scientific domains.{' '} 
        <Link href="/submit-manuscript" sx={{ color: '#1976d2', fontWeight: 500 }} underline="hover">
          submit here.
        </Link>
        {' '}
        For any inquiries, contact us at{' '}
        <Link href="mailto:info@wajls.com" sx={{ color: '#1976d2' }} underline="hover">
          info@wajls.com
        </Link>.
      </Typography>

      {/* <Typography variant="body2">
        You can also reach us directly on{' '}
        <Link href="https://wa.me/2340000000000" // target="_blank" sx={{ color: '#1976d2', fontWeight: 500 }} underline="hover">
          WhatsApp <WhatsAppIcon fontSize="small" sx={{ verticalAlign: 'middle' }} />
        </Link>
        .
      </Typography> */}
    </Box>
  );
}

export default SubmitManuscriptCard;
